import { mountSearchFilterPopup } from './search-filter-mount';
import { initHeroSearchSubmission } from './hero-search-submit';

mountSearchFilterPopup();

(function () {
    'use strict';

    const TURKEY_COUNTRY_ID = '1';

    function searchUiText(source, replacements = {}) {
        const table = (window.HOME_SEARCH_I18N && typeof window.HOME_SEARCH_I18N === 'object')
            ? window.HOME_SEARCH_I18N
            : {};
        const fragments = (table.__fragments && typeof table.__fragments === 'object')
            ? table.__fragments
            : {};

        let text = Object.prototype.hasOwnProperty.call(table, source)
            ? String(table[source])
            : String(source ?? '');

        if (text === String(source ?? '') && text) {
            Object.keys(fragments)
                .sort((a, b) => b.length - a.length)
                .forEach(fragment => {
                    if (!fragment || !text.includes(fragment)) return;
                    text = text.split(fragment).join(String(fragments[fragment]));
                });
        }

        Object.entries(replacements || {}).forEach(([key, value]) => {
            text = text.split(':' + key).join(String(value ?? ''));
        });

        return text;
    }

    function safe(label, fn) {
        try { fn(); }
        catch (e) { console.error('[home] ' + label + ' failed:', e); }
    }

    function onReady(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn, { once: true });
        } else {
            fn();
        }
    }

    onReady(function () {
        safe('hero-tabs', initHeroTabs);
        safe('category-ui', initCategoryUi);
        safe('keyword-sync', initKeywordSync);
        safe('location-autocomplete', initLocationAutocomplete);
        safe('home-filter-submit-sync', initHeroSearchSubmission);
        safe('agency-autocomplete', initAgencyAutocomplete);
    });

    window.addEventListener('pageshow', function (e) {
        safe('hero-tabs-pageshow', function () {
            initHeroTabs(!!(e && e.persisted));
        });
    });

    function initHeroTabs() {
        const form = document.getElementById('heroSearchForm');
        const ttInput = document.getElementById('hsTransactionType');
        const modeInput = document.getElementById('hsSearchMode');
        const aiInput = document.getElementById('hsAi');
        const hsQ = document.getElementById('hsQ');
        const qHidden = document.getElementById('qHidden');
        const agencyNameWrap = document.getElementById('agencyNameWrap');
        const categoryWrap = document.getElementById('categoryWrap');
        const filterBtnWrap = document.getElementById('filterBtnWrap');
        const heroInputWrap = document.getElementById('heroSearchInputWrap');
        const tagBox = document.getElementById('hsLocationTag');
        const hiddenCat = document.getElementById('categoryIdHidden');
        const tagsWrap = document.querySelector('.hero-search-tags');

        const modeLinks = Array.from(document.querySelectorAll('.hero-search-tab a[data-mode]'));
        const ttLinks = Array.from(document.querySelectorAll('.hero-search-tab a[data-tt]'));
        const aiLinks = Array.from(document.querySelectorAll('.hero-search-tab a[data-ai]'));

        if (!form || !ttInput || !modeInput || !aiInput) return;

        const actionAd = form.dataset.actionAd || '';
        const actionAgency = form.dataset.actionAgency || '';
        const placeholderSale = form.dataset.placeholderSale || searchUiText('Adres, şehir, ilçe veya mahalle arayın. Örn: Kestel Bursa');
        const placeholderRent = form.dataset.placeholderRent || searchUiText('Adres, şehir, ilçe veya mahalle arayın. Örn: Kestel Bursa');
        const placeholderAgency = form.dataset.placeholderAgency || searchUiText('Adres veya bölge arayın. Örn: Kestel Bursa');
        const placeholderAi = form.dataset.placeholderAi || searchUiText('Hayalinizdeki evi tarif edin');

        function getAdPlaceholder() {
            return String(ttInput.value || '1') === '2' ? placeholderRent : placeholderSale;
        }

        function syncLocationTagUi(forceVisible = false) {
            if (!hsQ || !tagBox || !heroInputWrap) return;

            const hasTagContent = tagBox.innerHTML.trim() !== '';
            const hasSelection = !!(document.getElementById('acCityId')?.value || document.getElementById('acDistrictId')?.value || document.getElementById('acQuarterId')?.value || document.getElementById('acLocationLabel')?.value);
            const shouldShow = forceVisible && hasTagContent && hasSelection;

            if (!shouldShow) {
                tagBox.style.display = 'none';
                heroInputWrap.classList.remove('has-tag');
                hsQ.style.paddingLeft = '';
                return;
            }

            tagBox.style.display = 'flex';
            heroInputWrap.classList.add('has-tag');

            requestAnimationFrame(() => {
                const tagWidth = tagBox.offsetWidth || 0;
                hsQ.style.paddingLeft = tagWidth > 0 ? (tagWidth + 22) + 'px' : '';
            });
        }

        function resetHeroLocationState(clearKeyword = true) {
            const hCountry = document.getElementById('acCountryId');
            const hCity = document.getElementById('acCityId');
            const hDist = document.getElementById('acDistrictId');
            const hQuar = document.getElementById('acQuarterId');

            if (hCountry) { hCountry.value = TURKEY_COUNTRY_ID; hCountry.disabled = false; }
            if (hCity) { hCity.value = ''; hCity.disabled = true; }
            if (hDist) { hDist.value = ''; hDist.disabled = true; }
            if (hQuar) { hQuar.value = ''; hQuar.disabled = true; }

            if (tagBox) {
                tagBox.innerHTML = '';
            }

            syncLocationTagUi(false);

            if (clearKeyword) {
                if (hsQ) hsQ.value = '';
                if (qHidden) qHidden.value = '';
            }

            const resultsBox = document.getElementById('hsAutocompleteResults');
            if (resultsBox) resultsBox.style.display = 'none';
        }

        function syncTabVisualState() {
            const currentMode = modeInput.value || 'ad';
            const isAi = aiInput.value === '1';
            const currentTt = String(ttInput.value || '1');

            modeLinks.forEach(a => {
                const active = a.dataset.mode === currentMode;
                a.classList.toggle('active-mode', active);
                a.classList.toggle('active', active);
            });

            aiLinks.forEach(a => {
                a.classList.toggle('active', currentMode === 'ad' && isAi);
            });

            ttLinks.forEach(a => {
                const shouldBeActive = currentMode === 'ad' && !isAi && String(a.dataset.tt) === currentTt;
                a.classList.toggle('active', shouldBeActive);
            });
        }

        function bindKeywordInput(directTextMode) {
            if (!hsQ || !qHidden) return;

            if (directTextMode) {
                hsQ.setAttribute('name', 'q');
                qHidden.disabled = true;
            } else {
                hsQ.removeAttribute('name');
                qHidden.disabled = false;
            }
        }

        function applyModeState() {
            const currentMode = modeInput.value || 'ad';
            const isAi = aiInput.value === '1';
            const hasSelection = !!(document.getElementById('acCityId')?.value || document.getElementById('acDistrictId')?.value || document.getElementById('acQuarterId')?.value || document.getElementById('acLocationLabel')?.value);

            if (currentMode === 'agency') {
                form.setAttribute('action', actionAgency);
                if (agencyNameWrap) agencyNameWrap.style.display = 'block';
                if (categoryWrap) categoryWrap.style.display = 'none';
                if (filterBtnWrap) filterBtnWrap.style.display = 'none';
                if (heroInputWrap) heroInputWrap.style.flex = '1';
                if (agencyNameWrap) agencyNameWrap.style.flex = '1';
                if (hsQ) hsQ.placeholder = placeholderAgency;
                if (hiddenCat) hiddenCat.disabled = true;
                if (tagsWrap) tagsWrap.style.display = 'block';
                bindKeywordInput(true);
                syncLocationTagUi(hasSelection);
            } else {
                form.setAttribute('action', actionAd);
                if (agencyNameWrap) agencyNameWrap.style.display = 'none';
                if (hiddenCat) hiddenCat.disabled = false;

                if (isAi) {
                    if (categoryWrap) categoryWrap.style.display = 'none';
                    if (filterBtnWrap) filterBtnWrap.style.display = 'none';
                    if (heroInputWrap) heroInputWrap.style.flex = '1';
                    // AI sekmesinde de diğer sekmelerdeki güven/tagline satırı görünür kalır.
                    if (tagsWrap) tagsWrap.style.display = 'block';
                    if (hsQ) hsQ.placeholder = placeholderAi;
                    bindKeywordInput(true);
                    syncLocationTagUi(false);
                } else {
                    if (categoryWrap) categoryWrap.style.display = 'block';
                    if (filterBtnWrap) filterBtnWrap.style.display = 'block';
                    if (heroInputWrap) heroInputWrap.style.flex = '1.5';
                    if (tagsWrap) tagsWrap.style.display = 'block';
                    if (hsQ) hsQ.placeholder = getAdPlaceholder();
                    bindKeywordInput(false);
                    syncLocationTagUi(hasSelection);
                }
            }

            syncTabVisualState();
        }

        function setTransaction(tt) {
            const value = String(tt) === '2' ? '2' : '1';

            ttInput.value = value;
            form.dataset.lastTransactionType = value;

            if (window.NetteSearchFilter && typeof window.NetteSearchFilter.setTransactionType === 'function') {
                window.NetteSearchFilter.setTransactionType(value);
            }

            window.dispatchEvent(new CustomEvent('home-search-state-changed', {
                detail: {
                    transaction_type: value,
                },
            }));

            applyModeState();
        }

        function setAi(on) {
            const turnOn = !!on;

            if (turnOn) {
                form.dataset.lastTransactionType = ttInput.value || form.dataset.lastTransactionType || '1';
                ttInput.value = '';
            } else if (!ttInput.value) {
                ttInput.value = form.dataset.lastTransactionType || '1';
            }

            aiInput.value = turnOn ? '1' : '0';
            if (turnOn) resetHeroLocationState(true);
            applyModeState();
        }

        function setMode(mode) {
            modeInput.value = mode === 'agency' ? 'agency' : 'ad';

            if (modeInput.value === 'agency' && aiInput.value === '1') {
                aiInput.value = '0';
                if (!ttInput.value) {
                    ttInput.value = form.dataset.lastTransactionType || '1';
                }
            }

            applyModeState();
        }

        if (form.dataset.heroTabsBound !== '1') {
            form.dataset.heroTabsBound = '1';

            modeLinks.forEach(a => {
                a.addEventListener('click', function (e) {
                    e.preventDefault();
                    setMode(a.dataset.mode);
                });
            });

            ttLinks.forEach(a => {
                a.addEventListener('click', function (e) {
                    e.preventDefault();

                    const nextTt = String(a.dataset.tt || '1');
                    const currentTt = String(ttInput.value || '1');

                    if (currentTt !== nextTt) {
                        resetHeroLocationState(true);
                    }

                    setMode('ad');
                    setAi(false);
                    setTransaction(nextTt);
                });
            });

            aiLinks.forEach(a => {
                a.addEventListener('click', function (e) {
                    e.preventDefault();
                    setMode('ad');
                    setAi(aiInput.value !== '1');
                });
            });
        }

        if (!form.dataset.lastTransactionType) {
            form.dataset.lastTransactionType = ttInput.value || '1';
        }

        applyModeState();
    }

    function initCategoryUi() {
        const $heroIcon = $('.hero-search-category-icon');
        const $heroList = $('.hero-search-category-list');
        const heroLabel = document.getElementById('hsCategoryLabel');
        const mainHidden = document.getElementById('mainCategoryIdHidden');
        const subHidden = document.getElementById('subCategoryIdHidden');
        const effectiveHidden = document.getElementById('categoryIdHidden');

        function syncHeroCategoryState(input) {
            const value = input ? String(input.value || '') : '';
            const label = input ? ($(input).closest('label').find('small').text().trim() || searchUiText('Tümü')) : searchUiText('Tümü');

            if (mainHidden) mainHidden.value = value;
            if (subHidden) subHidden.value = '';
            if (effectiveHidden) {
                effectiveHidden.value = value;
                effectiveHidden.disabled = value === '';
            }

            if (heroLabel) heroLabel.textContent = label || searchUiText('Tümü');

            if (window.NetteSearchFilter && typeof window.NetteSearchFilter.setCategory === 'function') {
                window.NetteSearchFilter.setCategory(value, '');
            }

            window.dispatchEvent(new CustomEvent('home-search-state-changed', {
                detail: {
                    main_category_id: value,
                    subcategory_id: '',
                    category_id: value,
                },
            }));
        }

        $heroList.on('click', 'input[name="hero_main_category"]', function () {
            syncHeroCategoryState(this);
            $heroList.stop(true, true).slideUp(200, function () {
                $heroIcon.removeClass('hero-search-category-close');
            });
        });

        const checked = document.querySelector('.hero-search-category-list input[name="hero_main_category"]:checked');
        syncHeroCategoryState(checked);
    }

    function initKeywordSync() {
        const form = document.getElementById('heroSearchForm');
        const hsQ = document.getElementById('hsQ');
        const hidden = document.getElementById('qHidden');
        const mainHidden = document.getElementById('mainCategoryIdHidden');
        const subHidden = document.getElementById('subCategoryIdHidden');
        const effectiveHidden = document.getElementById('categoryIdHidden');
        const tagBox = document.getElementById('hsLocationTag');

        if (!form || !hidden) return;

        form.addEventListener('submit', function () {
            if (effectiveHidden) {
                effectiveHidden.value = (subHidden?.value || mainHidden?.value || '').trim();
            }

            if (hsQ && !hsQ.hasAttribute('name') && tagBox && tagBox.style.display === 'none') {
                hidden.value = hsQ.value.trim() !== '' ? hsQ.value.trim() : '';
            }
        });
    }

    function initLocationAutocomplete() {
        const wrap = document.getElementById('heroSearchInputWrap');
        const form = document.getElementById('heroSearchForm');
        const input = document.getElementById('hsQ');
        const resultsBox = document.getElementById('hsAutocompleteResults');
        const tagBox = document.getElementById('hsLocationTag');
        const qHidden = document.getElementById('qHidden');
        const locationLabelInput = document.getElementById('acLocationLabel');
        const hCountry = document.getElementById('acCountryId');
        const hCity = document.getElementById('acCityId');
        const hDist = document.getElementById('acDistrictId');
        const hQuar = document.getElementById('acQuarterId');

        if (!form || !input || !resultsBox) return;

        const searchUrl = form.dataset.locationSearchUrl;
        if (!searchUrl) return;

        let debounceTimer = null;
        let currentFocus = -1;

        if (wrap) {
            wrap.addEventListener('click', function (e) {
                if (!e.target.closest('.remove-tag')) {
                    input.focus();
                }
            });
        }

        input.addEventListener('input', function () {
            const aiInput = document.getElementById('hsAi');
            if (aiInput && aiInput.value === '1') return;

            const value = this.value.trim();

            if (tagBox && tagBox.style.display !== 'none') {
                resetSelection(false);
            }

            resetHiddenInputs();

            input.removeAttribute('name');
            if (qHidden) qHidden.value = '';

            if (value.length < 2) {
                closeAllLists();
                if (value.length === 0) resetSelection();
                return;
            }

            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => fetchResults(value), 250);
        });

        input.addEventListener('keydown', function (e) {
            const aiInput = document.getElementById('hsAi');
            const isAi = aiInput && aiInput.value === '1';
            const items = resultsBox.querySelectorAll('.ac-item');

            if (e.key === 'Enter') {
                if (isAi) return;

                if (resultsBox.style.display !== 'none' && items.length > 0) {
                    e.preventDefault();
                    if (currentFocus > -1) items[currentFocus].click();
                    else items[0].click();
                    return;
                }

                if (tagBox && tagBox.style.display !== 'none') {
                    return;
                }

                e.preventDefault();
                return;
            }

            if (e.key === 'Backspace' && input.value === '' && tagBox && tagBox.style.display !== 'none') {
                resetSelection();
                return;
            }

            if (e.key === 'ArrowDown') {
                currentFocus++;
                addActive(items);
            } else if (e.key === 'ArrowUp') {
                currentFocus--;
                addActive(items);
            }
        });

        async function fetchLocationItems(query) {
            try {
                const url = new URL(searchUrl, window.location.origin);
                url.searchParams.set('q', query);
                url.searchParams.set('smart', '1');
                url.searchParams.set('limit', '12');

                const tt = document.getElementById('hsTransactionType')?.value || '';
                const categoryId = document.getElementById('categoryIdHidden')?.value || '';

                url.searchParams.set('country_id', TURKEY_COUNTRY_ID);
                url.searchParams.set('only_turkey', '1');

                if (tt) url.searchParams.set('transaction_type', tt);
                if (categoryId) url.searchParams.set('category_id', categoryId);

                const res = await fetch(url, {
                    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
                });
                const data = await res.json();
                const items = Array.isArray(data.items) ? data.items : [];

                return items.filter(isTurkeyLocationItem);
            } catch (e) {
                console.error('Auto-location error:', e);
                return [];
            }
        }

        async function fetchResults(query) {
            const items = await fetchLocationItems(query);
            // The user may have switched to natural-language search mid-request.
            if (document.getElementById('hsAi')?.value === '1') return;
            renderResults(items);
        }

        function isTurkeyLocationItem(item) {
            if (!item) return false;

            const type = String(item.type || '');
            const id = String(item.id || '');
            const countryId = String(item.country_id || '');

            if (type === 'country') {
                return id === TURKEY_COUNTRY_ID || countryId === TURKEY_COUNTRY_ID;
            }

            return countryId === '' || countryId === TURKEY_COUNTRY_ID;
        }

        function renderResults(items) {
            items = (Array.isArray(items) ? items : []).filter(isTurkeyLocationItem);

            if (items.length === 0) {
                resultsBox.innerHTML = '<div class="ac-no-result">' + escapeHtml(searchUiText('Sonuç bulunamadı.')) + '</div>';
                resultsBox.style.display = 'block';
                return;
            }

            let html = '';
            items.forEach(item => {
                const labelText = item.label || item.name || '';
                const subText = item.full_label || item.sub || item.path || '';
                const selectedLabelText = item.full_label || item.label || item.name || '';

                const labelSafe = escapeHtml(labelText);
                const subSafe = escapeHtml(subText);
                const selectedLabelSafe = escapeHtml(selectedLabelText);
                const iconSafe = escapeHtml(item.icon || 'ph-map-pin');

                html += `
                    <div class="ac-item"
                         data-type="${escapeHtml(item.type || 'loc')}"
                         data-id="${escapeHtml(item.id || '')}"
                         data-country-id="${escapeHtml(item.country_id || '')}"
                         data-city-id="${escapeHtml(item.city_id || '')}"
                         data-district-id="${escapeHtml(item.district_id || '')}"
                         data-quarter-id="${escapeHtml(item.quarter_id || item.neighborhood_id || '')}"
                         data-label="${selectedLabelSafe}">
                        <div class="ac-icon">
                            <i class="ph-light ${iconSafe}"></i>
                        </div>
                        <div class="ac-info">
                            <span class="ac-label">${labelSafe}</span>
                            ${subSafe ? `<span class="ac-sub">${subSafe}</span>` : ''}
                        </div>
                    </div>
                `;
            });

            resultsBox.innerHTML = html;
            resultsBox.style.display = 'block';
            currentFocus = -1;

            resultsBox.querySelectorAll('.ac-item').forEach(el => {
                el.addEventListener('click', function () {
                    selectItem(this);
                });
            });
        }

        function selectItem(el) {
            applyLocationObject({
                type: el.dataset.type,
                id: el.dataset.id,
                country_id: el.dataset.countryId,
                city_id: el.dataset.cityId || (el.dataset.type === 'city' ? el.dataset.id : ''),
                district_id: el.dataset.districtId || (el.dataset.type === 'district' ? el.dataset.id : ''),
                quarter_id: el.dataset.quarterId || ((el.dataset.type === 'neighborhood' || el.dataset.type === 'quarter') ? el.dataset.id : ''),
                label: el.dataset.label,
                full_label: el.dataset.label,
            });
        }

        function applyLocationObject(item) {
            if (!item) return false;

            const type = String(item.type || '');
            const id = String(item.id || '');
            const label = item.full_label || item.label || item.name || '';
            const incomingCountryId = String(item.country_id || '');
            if (incomingCountryId && incomingCountryId !== TURKEY_COUNTRY_ID) {
                return false;
            }

            const countryId = TURKEY_COUNTRY_ID;
            const cityId = String(item.city_id || (type === 'city' ? id : '') || '');
            const districtId = String(item.district_id || (type === 'district' ? id : '') || '');
            const quarterId = String(item.quarter_id || item.neighborhood_id || ((type === 'neighborhood' || type === 'quarter') ? id : '') || '');

            resetHiddenInputs();

            if (hCountry) {
                hCountry.value = TURKEY_COUNTRY_ID;
                hCountry.disabled = false;
            }

            if (cityId && hCity) {
                hCity.value = cityId;
                hCity.disabled = false;
            }

            if (districtId && hDist) {
                hDist.value = districtId;
                hDist.disabled = false;
            }

            if (quarterId && hQuar) {
                hQuar.value = quarterId;
                hQuar.disabled = false;
            }

            if (locationLabelInput) {
                locationLabelInput.value = label;
                locationLabelInput.disabled = !label;
            }

            createTag(label);

            input.value = '';
            input.removeAttribute('name');
            if (qHidden) qHidden.value = '';

            window.dispatchEvent(new CustomEvent('home-search-state-changed', {
                detail: {
                    country_id: countryId,
                    city_id: cityId,
                    district_id: districtId,
                    quarter_id: quarterId,
                    location_label: label,
                    q: '',
                },
            }));

            closeAllLists();
            return true;
        }

        function createTag(text) {
            if (!tagBox) return;
            tagBox.innerHTML = `
                <i class="ph-fill ph-map-pin"></i>
                <span>${escapeHtml(text)}</span>
                <div class="remove-tag" title="${escapeHtml(searchUiText('Kaldır'))}"><i class="ph-bold ph-x"></i></div>
            `;
            tagBox.style.display = 'flex';
            if (wrap) wrap.classList.add('has-tag');

            requestAnimationFrame(() => {
                const tagWidth = tagBox.offsetWidth;
                input.style.paddingLeft = (tagWidth + 22) + 'px';
                input.focus();
            });

            tagBox.querySelector('.remove-tag').addEventListener('click', function (e) {
                e.stopPropagation();
                resetSelection();
                input.focus();
            });
        }

        function resetSelection(clearInput = true) {
            resetHiddenInputs();
            input.removeAttribute('name');
            if (qHidden) qHidden.value = '';

            if (clearInput) input.value = '';
            input.style.paddingLeft = '';

            if (tagBox) {
                tagBox.style.display = 'none';
                tagBox.innerHTML = '';
            }
            if (wrap) wrap.classList.remove('has-tag');
        }

        function resetHiddenInputs() {
            if (hCountry) { hCountry.value = TURKEY_COUNTRY_ID; hCountry.disabled = false; }
            if (hCity) { hCity.value = ''; hCity.disabled = true; }
            if (hDist) { hDist.value = ''; hDist.disabled = true; }
            if (hQuar) { hQuar.value = ''; hQuar.disabled = true; }
            if (locationLabelInput) { locationLabelInput.value = ''; locationLabelInput.disabled = true; }
        }

        function addActive(x) {
            if (!x) return false;
            removeActive(x);
            if (currentFocus >= x.length) currentFocus = 0;
            if (currentFocus < 0) currentFocus = x.length - 1;
            x[currentFocus].classList.add('ac-active');
            x[currentFocus].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }

        function removeActive(x) {
            for (let i = 0; i < x.length; i++) {
                x[i].classList.remove('ac-active');
            }
        }

        function closeAllLists() {
            resultsBox.style.display = 'none';
            currentFocus = -1;
        }

        window.NetteHomeLocationAutocomplete = {
            async resolveTypedLocation(query) {
                const q = String(query || '').trim();
                if (q.length < 2) return false;

                const items = await fetchLocationItems(q);
                if (!items.length) return false;

                return applyLocationObject(items[0]);
            },
            hasSelectedLocation() {
                return !!(hCity?.value || hDist?.value || hQuar?.value);
            }
        };

        document.addEventListener('click', function (e) {
            if (wrap && !wrap.contains(e.target)) {
                closeAllLists();
            }
        });

        function escapeHtml(text) {
            if (!text) return '';
            return text.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
        }
    }

    function initAgencyAutocomplete() {
        const input = document.getElementById('hsAgencyName');
        const resultsBox = document.getElementById('hsAgencyResults');
        if (!input || !resultsBox) return;

        let debounceTimer = null;

        function escapeHtml(text) {
            if (!text) return '';
            return text.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
        }

        const fetchAgencies = (query) => {
            const cleanQuery = String(query || '').trim();

            const cityId = document.getElementById('acCityId')?.value || '';
            const distId = document.getElementById('acDistrictId')?.value || '';
            const quarId = document.getElementById('acQuarterId')?.value || '';

            const hasLocation = !!(cityId || distId || quarId);

            /*
             * q boş ve bölge de seçili değilse autocomplete çalışmasın.
             * q boş ama bölge seçiliyse o bölgedeki acenteleri öneri olarak gösterebilir.
             */
            if (cleanQuery.length === 0 && !hasLocation) {
                resultsBox.innerHTML = '';
                resultsBox.style.display = 'none';
                return;
            }

            const url = new URL('/ajax/agencies', window.location.origin);
            url.searchParams.set('country_id', TURKEY_COUNTRY_ID);
            url.searchParams.set('only_turkey', '1');

            if (cleanQuery !== '') {
                url.searchParams.set('q', cleanQuery);
            }

            if (cityId) {
                url.searchParams.set('city_id', cityId);
            }

            if (distId) {
                url.searchParams.set('district_id', distId);
            }

            if (quarId) {
                url.searchParams.set('quarter_id', quarId);
            }

            fetch(url.toString(), {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json',
                },
            })
                .then(res => res.json())
                .then(data => {
                    resultsBox.innerHTML = '';

                    if (!data.items || data.items.length === 0) {
                        resultsBox.innerHTML = '<div class="ac-no-result" style="padding:15px; text-align:center; color:#888;">' + escapeHtml(searchUiText('Acente bulunamadı.')) + '</div>';
                    } else {
                        data.items.forEach(item => {
                            const div = document.createElement('div');
                            div.className = 'ac-item';
                            div.innerHTML = `
                        <div class="ac-icon"><i class="ph-light ph-storefront"></i></div>
                        <div class="ac-info"><span class="ac-label">${escapeHtml(item.name)}</span></div>
                    `;

                            div.addEventListener('click', () => {
                                input.value = item.name;
                                resultsBox.style.display = 'none';
                            });

                            resultsBox.appendChild(div);
                        });
                    }

                    resultsBox.style.display = 'block';
                })
                .catch(err => console.error('Agency auto-complete error:', err));
        };

        input.addEventListener('focus', function () {
            const query = this.value.trim();

            const cityId = document.getElementById('acCityId')?.value || '';
            const distId = document.getElementById('acDistrictId')?.value || '';
            const quarId = document.getElementById('acQuarterId')?.value || '';

            const hasLocation = !!(cityId || distId || quarId);

            if (query.length === 0 && !hasLocation) {
                resultsBox.innerHTML = '';
                resultsBox.style.display = 'none';
                return;
            }

            fetchAgencies(query);
        });

        input.addEventListener('input', function () {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                fetchAgencies(this.value.trim());
            }, 250);
        });

        document.addEventListener('click', function (e) {
            if (!input.contains(e.target) && !resultsBox.contains(e.target)) {
                resultsBox.style.display = 'none';
            }
        });
    }
})();
